/**
 * @Author proudlx
 * @Description 登录相关接口
 */
import request from "@/api/http/request";
import {
  POST_LOGIN_MAIN,
  POST_LOGIN_MAIN_V2,
  POST_STUDENT_USERINFO,
  POST_LOGOUT,
  POST_LOGIN_VISITOR,
  POST_LOGIN_VISITOR_UPGRADE,
  POST_HOME_MARKET_DATA,
  POST_LOGIN_FEISHU_AUTH,
} from "@/api/apiConst/login";

export function getTT4BWebAccountInfo(data: { visitor?: string }) {
  return request.post<{ token?: string; agent?: string; ksxAgents?:string }>(POST_LOGIN_MAIN, data, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  });
}
export function getLogin(data: { username: string; visitor?: string }) {
  return request.post<{ token?: string; agent?: string; ksxAgents?:string}>(POST_LOGIN_MAIN, data, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  });
}

export function getTT4BWebAccountInfoV2(data: { visitor?: string }) {
  return request.post<{ token?: string; agent?: string; ksxAgents?:string }>(POST_LOGIN_MAIN_V2, data, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  });
}
export function getLoginV2(data: { username: string; visitor?: string }) {
  return request.post<{ token?: string }>(POST_LOGIN_MAIN_V2, data, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  });
}

export interface userInfoType {
  agents?: string;
  ksxAgents?: string;
  name: string;
  /** 0游客 1代理商 2品牌方 3内部员工*/
  type: string;
  useType?: string;
  useSubject?: string;
  /** 剩余信息审核次数 */
  num: number;
  /** 提交的信息审核次数 */
  subjectNum: number | null;
  id: number;
  icon?: string;
  iconName?: string;
  locked: boolean;
  email: string;
  mobile: string;
  /**0不连播 1连播 */
  playStatus: 0 | 1;
  uid: string;
  subject?: string;
  subjectId?: string;
  spStatus: 0 | 1;
  marketId?: string;
  agent?: string;
}
export function getUserInfo() {
  return request.post<userInfoType>(POST_STUDENT_USERINFO);
}
export function getLogout() {
  return request.post(
    POST_LOGOUT,
    {},
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    }
  );
}
/** 游客登录 */
export function getLoginVisitor() {
  return request.post<{ token: string; token_type: "0"; username: string }>(
    POST_LOGIN_VISITOR,
    {},
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    }
  );
}
/** 游客升级 */
export function getLoginVisitorUpgrade() {
  return request.post(POST_LOGIN_VISITOR_UPGRADE);
}
/** 首页数据 */
export function getHomeMarketData(headers?: { [key: string]: string }) { 
  return request.post<{
    businessId: string;
    name: string;
  }[]>(POST_HOME_MARKET_DATA,{},{
    headers: {
      "Content-Type": "application/json;charset=UTF-8", 
       ...headers
    },
  });
}

/** 飞书认证 */
export function feishuAuth(data: { code: string }) {
  return request.post<{ token?: string }>(POST_LOGIN_FEISHU_AUTH, data, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
  });
}
